import Skeleton from './Skeleton';

const BookCardSkeleton = () => (
  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
    <Skeleton className="w-full h-64" />
    <div className="p-5 space-y-3">
      <Skeleton className="h-6 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-3 w-full" />
    </div>
  </div>
);

export default BookCardSkeleton;
